// Components
import { Modal, ModalSize } from '@/components';
import {
  StyledModalButtonsWrapper,
  StyledModalContentWrapper,
  StyledModalDescription,
  StyledModalTitle,
} from './DeleteModalStyles';
import { Button } from '@/ui';

type TDeleteModal = {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  closeBtnText: string;
  confirmBtnText: string;
};

const DeleteModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  title,
  description,
  closeBtnText,
  confirmBtnText,
}: TDeleteModal) => {
  return (
    <Modal visible={isOpen} onCancel={onClose} size={ModalSize.LARGE}>
      <StyledModalContentWrapper>
        <StyledModalTitle>{title}</StyledModalTitle>
        {description && <StyledModalDescription>{description}</StyledModalDescription>}

        <StyledModalButtonsWrapper>
          <Button onClick={onClose}>{closeBtnText}</Button>
          <Button onClick={onConfirm} type="text" loading={isLoading}>
            {confirmBtnText}
          </Button>
        </StyledModalButtonsWrapper>
      </StyledModalContentWrapper>
    </Modal>
  );
};

export default DeleteModal;
